import React from 'react';
import AdminProductCard from './AdminProductCard';

const BookGrid = ({ books = [], onEditBook = () => {}, searchQuery = '', highlightSearchTerm = null }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {books.map((item) => (
        <AdminProductCard
          key={`${item.productType || 'product'}-${item.id || item.id_product || Math.random()}`}
          book={item}
          onEdit={onEditBook}
          searchQuery={searchQuery}
          highlightSearchTerm={highlightSearchTerm}
        />
      ))}
    </div>
  );
};

export default BookGrid;
